import cSpinner from '#themes/default/default/components/spinner/spinner.js';

import template from './button.html' with { type: 'html' };

export default {
	name: 'CButton',
	components: {
		cSpinner
	},
	props: {
		customClass: {
			type: String,
			default: ''
		},
		design: {
			type: String,
			default: 'primary'
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		path: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'button'
		}
	},
	template
};
